import type { ColumnType } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { StyledMoreDetailsIcon } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/prompts-report/prompts-widget/PromptsComponent.styled";
import { TopicShareBar } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sentiment-report/topics-graph/TopicShareBar";
import type { ISentiment } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import type { ISentimentTabData, ITopicSentimentTableRow } from "./types";
import { SentimentTab } from "./types";

export const TOPIC_COLUMN_WIDTH = 300;

export const SIDE_PANEL_TABS_CONFIG: Record<SentimentTab, ISentimentTabData> = {
    [SentimentTab.Positive]: {
        tabTextKey: "llm.sentiment_report.topics.side-panel.tabs.positive",
        badgeTextKey: "llm.sentiment_report.topics.side-panel.badge.positive",
    },
    [SentimentTab.Neutral]: {
        tabTextKey: "llm.sentiment_report.topics.side-panel.tabs.neutral",
        badgeTextKey: "llm.sentiment_report.topics.side-panel.badge.neutral",
    },
    [SentimentTab.Negative]: {
        tabTextKey: "llm.sentiment_report.topics.side-panel.tabs.negative",
        badgeTextKey: "llm.sentiment_report.topics.side-panel.badge.negative",
    },
};

export const COLUMNS_CONFIG: Array<ColumnType<ITopicSentimentTableRow>> = [
    {
        dataIndex: "topicName",
        get title() {
            return translate("llm.sentiment_analysis.topics.column.topic.title");
        },
        get tooltipSubtitle() {
            return translate("llm.sentiment_analysis.topics.column.topic.tooltip");
        },
        align: "left",
        width: TOPIC_COLUMN_WIDTH,
        render: (topicName: string) => (
            <Flex
                alignItems="center"
                justifyContent="space-between"
            >
                <TruncatedTextWithTooltip
                    fontVariant="input2"
                    color={colorsPalettes.carbon[400]}
                >
                    {topicName}
                </TruncatedTextWithTooltip>
                <StyledMoreDetailsIcon
                    iconName="show-details"
                    size="sm"
                />
            </Flex>
        ),
    },
    {
        dataIndex: "sentiment",
        get title() {
            return translate("llm.sentiment_analysis.topics.column.my-sentiment.title");
        },
        get tooltipSubtitle() {
            return translate("llm.sentiment_analysis.topics.column.my-sentiment.tooltip");
        },
        align: "left",
        render: (sentiment: ISentiment, row: ITopicSentimentTableRow) => (
            <TopicShareBar
                topicName={row?.topicName}
                sentiment={sentiment}
            />
        ),
    },
];
